import React, { useState } from 'react';
import { Modal } from './ui/Modal';
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  return <>
      <footer className="py-8 border-t border-white/5 bg-primary" data-id="element-43">
        <div className="max-w-4xl mx-auto px-4 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-44">
          <p className="text-text-muted text-sm" data-id="element-45">
            © {new Date().getFullYear()} Embudo Exprés. Todos los derechos
            reservados.
          </p>
          <div className="flex items-center gap-6" data-id="element-46">
            <button onClick={() => setActiveModal('privacy')} className="text-text-muted text-sm hover:text-white transition-colors" data-id="element-47">
              Política de Privacidad
            </button>
            <span className="text-white/10" data-id="element-48">|</span>
            <button onClick={() => setActiveModal('terms')} className="text-text-muted text-sm hover:text-white transition-colors" data-id="element-49">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <Modal isOpen={activeModal === 'privacy'} onClose={() => setActiveModal(null)} title="Política de Privacidad" data-id="element-50">
        <p className="text-white font-semibold text-base" data-id="element-51">
          Política de Privacidad — Embudo Exprés
        </p>
        <p data-id="element-52">
          Última actualización:{' '}
          {new Date().toLocaleDateString('es-MX', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })}
        </p>

        <p className="text-white font-medium mt-4" data-id="element-53">
          1. Información que recopilamos
        </p>
        <p data-id="element-54">
          Al adquirir nuestro producto digital, recopilamos únicamente la
          información necesaria para procesar tu compra: nombre, dirección de
          correo electrónico y datos de pago. No almacenamos información de
          tarjetas de crédito directamente; los pagos son procesados por
          plataformas de pago seguras de terceros.
        </p>

        <p className="text-white font-medium mt-4" data-id="element-55">2. Uso de la información</p>
        <p data-id="element-56">
          Utilizamos tu información exclusivamente para: entregar el producto
          digital adquirido, enviarte el acceso de descarga, y comunicarnos
          contigo respecto a tu compra. No vendemos, alquilamos ni compartimos
          tu información personal con terceros con fines de marketing.
        </p>

        <p className="text-white font-medium mt-4" data-id="element-57">3. Protección de datos</p>
        <p data-id="element-58">
          Implementamos medidas de seguridad técnicas y organizativas para
          proteger tu información personal contra acceso no autorizado,
          alteración, divulgación o destrucción.
        </p>

        <p className="text-white font-medium mt-4" data-id="element-59">4. Cookies</p>
        <p data-id="element-60">
          Nuestro sitio puede utilizar cookies esenciales para el funcionamiento
          básico de la página y cookies analíticas para entender cómo los
          visitantes interactúan con el sitio. Puedes desactivar las cookies en
          la configuración de tu navegador.
        </p>

        <p className="text-white font-medium mt-4" data-id="element-61">5. Tus derechos</p>
        <p data-id="element-62">
          Tienes derecho a acceder, rectificar o eliminar tu información
          personal en cualquier momento. Para ejercer estos derechos, puedes
          comunicarte con nosotros a través de los canales disponibles en
          nuestra plataforma.
        </p>

        <p className="text-white font-medium mt-4" data-id="element-63">
          6. Cambios a esta política
        </p>
        <p data-id="element-64">
          Nos reservamos el derecho de actualizar esta política de privacidad en
          cualquier momento. Los cambios serán publicados en esta página con la
          fecha de actualización correspondiente.
        </p>
      </Modal>

      {/* Terms & Conditions Modal */}
      <Modal isOpen={activeModal === 'terms'} onClose={() => setActiveModal(null)} title="Términos y Condiciones" data-id="element-65">
        <p className="text-white font-semibold text-base" data-id="element-66">
          Términos y Condiciones — Embudo Exprés
        </p>
        <p data-id="element-67">
          Última actualización:{' '}
          {new Date().toLocaleDateString('es-MX', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })}
        </p>

        <p className="text-white font-medium mt-4" data-id="element-68">1. Producto digital</p>
        <p data-id="element-69">
          Embudo Exprés es un producto digital en formato PDF interactivo que
          incluye plantillas, checklists y frameworks para la creación de
          embudos de venta. El producto se entrega mediante descarga inmediata
          tras la confirmación del pago.
        </p>

        <p className="text-white font-medium mt-4" data-id="element-70">2. Licencia de uso</p>
        <p data-id="element-71">
          Al adquirir el producto, obtienes una licencia personal e
          intransferible para usar el contenido. No está permitido redistribuir,
          revender, compartir públicamente ni reproducir el material con fines
          comerciales sin autorización expresa.
        </p>

        <p className="text-white font-medium mt-4" data-id="element-72">3. Resultados</p>
        <p data-id="element-73">
          Los resultados obtenidos con el uso de este producto dependen del
          esfuerzo, dedicación y circunstancias individuales de cada usuario. No
          garantizamos ingresos específicos ni resultados financieros
          determinados.
        </p>

        <p className="text-white font-medium mt-4" data-id="element-74">4. Política de reembolso</p>
        <p data-id="element-75">
          Debido a la naturaleza digital del producto y su entrega inmediata,
          todas las ventas son finales. No se ofrecen reembolsos una vez que el
          producto ha sido descargado o el acceso ha sido otorgado.
        </p>

        <p className="text-white font-medium mt-4" data-id="element-76">5. Propiedad intelectual</p>
        <p data-id="element-77">
          Todo el contenido del producto, incluyendo textos, diseños, plantillas
          y frameworks, es propiedad intelectual de Embudo Exprés. Está
          protegido por las leyes de derechos de autor aplicables.
        </p>

        <p className="text-white font-medium mt-4" data-id="element-78">
          6. Limitación de responsabilidad
        </p>
        <p data-id="element-79">
          Embudo Exprés no se hace responsable de pérdidas directas o indirectas
          derivadas del uso o la imposibilidad de uso del producto. El material
          se proporciona "tal cual" con fines educativos e informativos.
        </p>

        <p className="text-white font-medium mt-4" data-id="element-80">7. Modificaciones</p>
        <p data-id="element-81">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Las modificaciones entrarán en vigor desde su publicación en
          esta página.
        </p>
      </Modal>
    </>;
}